import {css} from '@emotion/css';
import {Breakpoints, mq} from '../../../styles/js/mixins';
import {colours, fonts, spacing} from '../../../styles/js/variables';

const styles = {
  customerStories: css`
    label: customerStories;
    .contentCard {
      height: calc(100% - ${spacing.XS});
    }

    ${mq(Breakpoints.TABLET)} {
      text-align: center;
    }
  `,
  link: css`
    label: customerStories__link;
    text-decoration: none;
  `,
  contentWrapper: css`
    label: customerStories__contentWrapper;
    padding: ${spacing.XS};
    color: ${colours.font.DARK_GRAY};
  `,
  quote: css`
    label: customerStories__quote;
    margin: 0;
    color: ${colours.font.ASSISTIVE};
  `,
  business: css`
    label: customerStories__business;
    margin-bottom: 0;
    margin-top: ${spacing.XXS};
    color: ${colours.font.ASSISTIVE};
    font-weight: ${fonts.weight.REGULAR};
    font-size: 1.4rem;
  `,
  customer: css`
    label: customerStories__customer;
    color: ${colours.font.BLACK};
    font-weight: ${fonts.weight.MEDIUM};
  `,
  caseStudy: css`
    label: customerStories__caseStudy;
    color: ${colours.font.DARK_GRAY};
    display: inline;
    text-decoration: underline;
  `,
  cta: css`
    label: customerStories__cta;
    margin-top: ${spacing.L};

    ${mq(Breakpoints.TABLET)} {
      margin-top: ${spacing.S};
    }
  `,
};

export default styles;
